import React from 'react'
import CurrencyFormat from 'react-currency-format'


const Goals = props => {
    const goals = props.goals

    return (
        <div className="columns">
            <div className="column">
                <table className='table is-bordered is-fullwidth table-detail'>
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>línea de acción</th>
                            <th>eje temático</th>
                            <th>nombre</th>
                            <th>monto solicitado</th>
                            <th>monto aprobado</th>
                            <th>monto ejercido</th>
                        </tr>
                    </thead>
                    <tbody>
                        {goals.map((goal, key) =>
                            <tr key={key}>
                                <td>{key + 1}</td>
                                <td>{goal.proigualdad_line}</td>
                                <td>{goal.proigualdad_axis}</td>
                                <td>{goal.name}</td>
                                <td className='has-text-right'>
                                    <CurrencyFormat
                                        value={parseFloat(goal.application_amount) || 0}
                                        displayType={'text'}
                                        thousandSeparator={true}
                                        prefix={'$'}
                                    />
                                </td>
                                <td className='has-text-right'>
                                    <CurrencyFormat
                                        value={parseFloat(goal.approved_amount) || 0}
                                        displayType={'text'}
                                        thousandSeparator={true}
                                        prefix={'$'}
                                    />
                                </td>
                                <td className='has-text-right'>
                                    <CurrencyFormat
                                        value={parseFloat(goal.disbursed_amount) || 0}
                                        displayType={'text'}
                                        thousandSeparator={true}
                                        prefix={'$'}
                                    />
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Goals


// WEBPACK FOOTER //
// ./src/acervo/components/Sections/Detail/Goals.js